import request from "../libs/request";

const baseUrl = "alarm";

export type UserPushInfo = {
  incommodity?: boolean;
  service?: boolean;
  rent?: boolean;
  reservation?: boolean;
  talkReply?: boolean;
  advertise?: boolean;
};

export const getUserPush = () => request.get(baseUrl);

export const updateUserPush = (params: UserPushInfo) =>
  request.put(baseUrl, params);

export type ManagerPushInfo = {
  donSturb: boolean;
  donSturbEnd: string;
  donSturbStart: string;
  incommodityCleaning: boolean;
  incommodityCommon: boolean;
  incommodityEtc: boolean;
  incommodityFacility: boolean;
  monitoring: boolean;
  rent: boolean;
  reservation: boolean;
  restaurant: boolean;
  service: boolean;
  incommodityManage: boolean;
  incommodityCommunication: boolean;
  temperature: boolean;
};

export const getManagerPush = () => request.get(`${baseUrl}/manager`);

export const updateManagerPush = (params: ManagerPushInfo) =>
  request.put(`${baseUrl}/manager`, params);
